/* eslint-disable */
<template>
  <div>

    <vx-card class="mt-4">
      <!-- SEARCH BAR -->
        <div class="flex justify-end">
          <div class="px-4 w-full">
            <label>Data do portfolio</label>
            <vs-select
              v-model="portfolio"
              class="w-full">
              <vs-select-item :key="index" :value="item.portfolioDate" :text="item.portfolioDate" v-for="(item, index) in portfolios" />
            </vs-select>
          </div>
          <div class="px-4 w-full">
            <vs-input label="Nome" v-model="name" @keyup.enter="refine(cnpj, name, idThunders, portfolio)"
                          @keyup.esc="refine(cnpj, name, idThunders, portfolio)" class="w-full"/>
          </div>
          <div class="px-4 w-full">
            <CnpjInput label="Cnpj" v-model="cnpj" @keyup.enter="refine(cnpj, name, idThunders, portfolio)"
                          @keyup.esc="refine(cnpj, name, idThunders, portfolio)" class="w-full"/>
          </div>
          <div class="px-4 w-full">
            <vs-input label="Id Interno" class="w-full" v-model="idThunders"
                  @keyup.enter="refine(cnpj, name, idThunders, portfolio)" @keyup.esc="refine(cnpj, name, idThunders, portfolio)"/>
          </div>
          <div class="self-end mb-1 px-4 w-full">
            <vs-button class="w-full" @click="clearFilter()" icon-pack="fa" icon="fa-eraser" title="Limpar"><span
              class="auto-hide-clear-text">Limpar</span></vs-button>
          </div>
          <div class="self-end mb-1 px-4 w-full">
            <vs-button class="w-full" @click="refine(cnpj, name, idThunders, portfolio)" icon="search">Buscar</vs-button>
          </div>
        </div>

    </vx-card>

    <vx-card class="mt-4">


      <div>
        <span class="font-semibold">Portfolio: {{lastPortfolio}}</span>
      </div>
      <div class="flex justify-end">
        <vs-button @click="downloadGuarantee">Download das garantias vencidas</vs-button>
      </div>


      <div class="mt-4">
        <vs-table stripe :data="guarantees" noDataText="Nenhum registro encontrado.">
          <template slot="thead">
            <th>Id Interno</th>
            <th>Cliente</th>
            <th>Cnpj</th>
            <th>Operação</th>
            <th>Tipo Garantia</th>
            <th>Valor da Garantia</th>
            <th>Data da Contratação</th>
            <th>Data Inicial da Garantia</th>
            <th>Meses Aportados</th>
            <th>Data Vencimento</th>
            <th>Status da Garantia</th>
            <th>Instituição Financeira</th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(row, indextr) in data">
              <td>
                <a role="button" style="cursor: pointer" @click="view(row.guid)">{{row.idThunders}}</a>
              </td>
              <td>
                {{row.clientName}}
              </td>
              <td>
                {{(row.cnpjClientAlfa || row.cnpjClient) | formatCnpj}}
              </td>
              <td>
                {{row.operationType | formatOperationType}}
              </td>
              <td>
              <span v-if="row.contracts.length > 0">
                {{row.contracts[row.contracts.length - 1].guaranteeType | formatGuarantee}}
              </span>
              </td>
              <td>
              <span v-if="row.contracts.length > 0">
                {{row.contracts[row.contracts.length - 1].guaranteeAmount | toDecimal}}
              </span>
              </td>
              <td>
                <span v-if="row.contracts.length > 0">
                {{row.contracts[row.contracts.length - 1].contractDate | formatDate}}
                </span>
              </td>
              <td>
                <span v-if="row.contracts.length > 0">
                {{row.contracts[row.contracts.length - 1].startDate | formatDate}}
                </span>
              </td>
              <td>
              <span v-if="row.contracts.length > 0">
                {{row.contracts[row.contracts.length - 1].monthCoverage}}
              </span>
              </td>
              <td>
                {{row.dueDate}}
              </td>
              <td>
                <span v-if="row.overDue === true" class="text-danger">Vencida</span>
                <span v-else-if="row.overDue === false">Vigente</span>
                <span v-else-if="row.overDue === null" class="text-danger">Sem garantia</span>
              </td>
              <td>
              <span v-if="row.contracts.length > 0">
                {{row.contracts[row.contracts.length - 1].financialInstitution.company.name}}
              </span>
              </td>

            </vs-tr>
          </template>
        </vs-table>

        <div class="my-5">
          <vs-pagination
            v-model="page"
            :total="totalPages">
          </vs-pagination>
        </div>
      </div>

    </vx-card>

  </div>
</template>

<script>
import CnpjInput from "@/components/CnpjInput"
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pt-br'
import axios from "axios"
import portfolioList from "@/mixins/Portfolio";

export default {
  name: "GarantiaList",
  components: {
    CnpjInput,
    DatePicker,
  },
  mixins:[portfolioList],
  watch: {
    page () {
      this.loadGuarantees()
    }
  },
  data () {
    return {
      cnpj: '',
      name: '',
      idThunders: '',
      portfolio: '',
      lastPortfolio: '',
      portfolios: [],
      guarantees:[],
      page: 1,
      totalPages: 0,
    }
  },
  beforeMount() {
    this.loadPortfolios()
  },
  methods: {

    refresh () {
      this.loadGuarantees()
    },

    loadGuarantees () {
      this.lastPortfolio = this.portfolio
      axios.get(`${process.env.VUE_APP_API  }/api/v1/guarantee/list`,
        {
          params: {
            page: this.page - 1,
            cnpj: this.cnpj,
            name: this.name,
            idThunders: this.idThunders,
            portfolioDate: this.portfolio
          }
        })
        .then((response) => {
          this.guarantees = response.data.content
          this.totalPages = response.data.totalPages
        })
    },

    refine (cnpj, name, idThunders, portfolio) {
      this.cnpj = cnpj
      this.name = name
      this.idThunders = idThunders
      this.portfolio = portfolio
      this.page = 1
      this.refresh()
    },

    clearFilter () {
      this.cnpj = null
      this.name = ''
      this.idThunders = ''
      this.page = 1
      this.refresh()
    },

    view (guid) {
      this.$router.push({path: `/guarantee/${guid}`})
    },

    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },

    loadPortfolios () {
      axios.get(`${process.env.VUE_APP_API}/api/v1/portfolio`,{
          params: {
            limit: 999,
          }
        }
      )
        .then((response) => {
          this.portfolios = response.data.content
          if (this.portfolios !== null && this.portfolios.length > 0) {
            this.portfolio = this.portfolios[0].portfolioDate
          }
        })
        .finally(() => {
          this.loadGuarantees()
        })
    },

    downloadGuarantee () {
      axios.get(`${process.env.VUE_APP_API}/api/v1/guarantee/excel/${this.portfolioGuid}`,
        {
          responseType: 'blob'
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
      })
    },

    downloadTemplate () {
      axios.get(`${process.env.VUE_APP_API}/api/v1/guarantee/excel/template`,
        {
          responseType: 'blob'
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
    }

  }
}
</script>

<style scoped>
/* Don't forget to hide the original file input! */
.file-select > input[type="file"] {
  display: none;
}
</style>
